import React, { Component } from "react";
import { defineMessages } from "react-intl";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "assets/scripts/components/common/form/Form/Form";
import PasswordCreateInputs, { getErrors } from "./PasswordCreateInputs/PasswordCreateInputs";
const messages = defineMessages({
    submit: {
        id: "forms.passwordCreate.submit",
        defaultMessage: "OK"
    }
});
export default class PasswordCreateForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            securityQuestion: "",
            securityAnswer: "",
            password: "",
            passwordConfirm: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const errors = getErrors(value);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<PasswordCreateInputs value={value} errors={errors} backendErrors={backendErrors} securityQuestions={props.securityQuestions} locale={props.locale} onChange={it => this.setState(it)}/>
			</Form>);
    }
    _handleSubmit() {
        this.props.createUser(this.state, this.props.validationRequest);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/PasswordCreateForm.tsx